import React, { useState, useEffect } from 'react';
import { TextField, SegmentedControl, Icon, Flex } from '@scale/scaleui-radix';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import useDebouncedValue from 'react-scale/hooks/useDebouncedValue';
import {
  GetCollectionsSearchParams,
  WebinarStartFilter,
} from '@scale/shared/webinarSessions/types';

type Props = {
  params: GetCollectionsSearchParams;
  setParams: (params: Partial<GetCollectionsSearchParams>) => void;
};

const WebinarCollectionsHeader: React.FC<Props> = ({ params, setParams }) => {
  const [localSearch, setLocalSearch] = useState(params.search || '');
  const debouncedLocalSearch = useDebouncedValue<string>(localSearch, 500);

  const selectedSegment = params.hostedByCurrentUser
    ? 'mine'
    : params.startFilter === 'PAST'
    ? 'past'
    : 'upcoming';

  useEffect(() => {
    if (debouncedLocalSearch) {
      setParams({ search: debouncedLocalSearch });
    } else {
      setParams({ search: undefined });
    }
  }, [debouncedLocalSearch, setParams]);

  return (
    <Flex justify="between" align="center">
      <SegmentedControl.Root
        defaultValue={selectedSegment}
        size="2"
        variant="surface"
        onValueChange={value => {
          if (value === 'mine') {
            setParams({
              hostedByCurrentUser: true,
              startFilter: WebinarStartFilter.ALL,
              page: undefined,
              pageSize: undefined,
            });
          } else if (value === 'upcoming') {
            setParams({
              hostedByCurrentUser: undefined,
              startFilter: WebinarStartFilter.UPCOMING,
              page: undefined,
              pageSize: undefined,
            });
          } else if (value === 'past') {
            setParams({
              hostedByCurrentUser: undefined,
              startFilter: WebinarStartFilter.PAST,
              page: undefined,
              pageSize: undefined,
            });
          }
        }}
      >
        <SegmentedControl.Item value="mine">My sessions</SegmentedControl.Item>
        <SegmentedControl.Item value="upcoming">Upcoming sessions</SegmentedControl.Item>
        <SegmentedControl.Item value="past">Past sessions</SegmentedControl.Item>
      </SegmentedControl.Root>
      <TextField.Root
        size="2"
        placeholder="Search ... "
        value={localSearch}
        onChange={event => setLocalSearch(event.target.value)}
        style={{ width: '350px' }}
      >
        <TextField.Slot side="left">
          <Icon icon={faSearch} label="Search" size="2" />
        </TextField.Slot>
      </TextField.Root>
    </Flex>
  );
};

export default WebinarCollectionsHeader;
